// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8217fca9","577":"3144f78e","593":"fa31b342"}[chunkId] + ".chunk.js";
};